import { Typography, Grid, Box, SxProps, Theme } from "@mui/material";
import { Search, Build, Warning, Assessment } from "@mui/icons-material";
import { SectionContainer } from "src/modules/SectionContainer/SectionContainer";
import { SectionTitle } from "src/modules/SectionTitle/SectionTitle";
import { SectionSubtitle } from "src/modules/SectionSubtitle/SectionSubtitle";
import { IconCircle } from "src/modules/IconCircle/IconCircle";
import { Card } from "../../modules";

export const Overview = () => {
  return (
    <SectionContainer sx={{ background: "white" }}>
      <SectionTitle>AMSPサービスとは</SectionTitle>
      <SectionSubtitle>
        アドバンスドマネージドサービスプロバイダー（AMSP）は、お客様のITインフラの運用・保守を包括的にサポートするサービスです
      </SectionSubtitle>

      <Grid container spacing={4} sx={{ marginBottom: "60px" }}>
        <Grid item xs={12} md={6}>
          <Box sx={overviewContentSx}>
            <Typography variant="h3" sx={overviewTitleSx}>
              従来のIT運用の課題
            </Typography>
            <Box component="ul" sx={overviewListSx}>
              <li>専門知識を持つエンジニアの確保が困難</li>
              <li>24時間365日の監視体制の構築コスト</li>
              <li>突発的なトラブルへの対応リソース不足</li>
              <li>最新技術の習得・導入に時間がかかる</li>
              <li>運用コストの最適化が難しい</li>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box sx={overviewContentSx}>
            <Typography variant="h3" sx={overviewTitleSx}>
              AMSPサービスのメリット
            </Typography>
            <Box component="ul" sx={overviewListSx}>
              <li>専門エンジニアによる高度な技術サポート</li>
              <li>24時間365日の継続的な監視・運用</li>
              <li>迅速な問題検知・対応によるダウンタイム最小化</li>
              <li>最新技術の継続的な導入・最適化</li>
              <li>予測可能な運用コストとROI向上</li>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Box>
        <Typography variant="h3" sx={servicesTitleSx}>
          主なサービス内容
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={serviceItemSx}>
              <IconCircle size="medium" variant="primary">
                <Search sx={{ fontSize: "24px" }} />
              </IconCircle>
              <Card.Title>システム監視</Card.Title>
              <Typography variant="body2" sx={serviceItemDescriptionSx}>
                サーバー、ネットワーク、アプリケーションの24時間監視
              </Typography>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={serviceItemSx}>
              <IconCircle size="medium" variant="info">
                <Build sx={{ fontSize: "24px" }} />
              </IconCircle>
              <Card.Title>運用・保守</Card.Title>
              <Typography variant="body2" sx={serviceItemDescriptionSx}>
                日常的な運用作業と定期メンテナンスの実施
              </Typography>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={serviceItemSx}>
              <IconCircle size="medium" variant="warning">
                <Warning sx={{ fontSize: "24px" }} />
              </IconCircle>
              <Card.Title>インシデント対応</Card.Title>
              <Typography variant="body2" sx={serviceItemDescriptionSx}>
                トラブル発生時の迅速な対応と復旧作業
              </Typography>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={serviceItemSx}>
              <IconCircle size="medium" variant="success">
                <Assessment sx={{ fontSize: "24px" }} />
              </IconCircle>
              <Card.Title>レポート・分析</Card.Title>
              <Typography variant="body2" sx={serviceItemDescriptionSx}>
                システム稼働状況の定期レポートと改善提案
              </Typography>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </SectionContainer>
  );
};

const overviewContentSx: SxProps<Theme> = (theme) => ({
  background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
  padding: "40px",
  borderRadius: "15px",
  // boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
  [theme.breakpoints.down("md")]: {
    padding: "30px 20px",
  },
  height: "100%",
});

const overviewTitleSx: SxProps<Theme> = {
  fontSize: "1.5rem",
  marginBottom: "25px",
  color: "#1a1a2e",
  fontWeight: 600,
};

const overviewListSx: SxProps<Theme> = {
  listStyle: "none",
  margin: 0,
  padding: 0,
  "& li": {
    padding: "12px 0",
    color: "#555",
    borderBottom: "1px solid #f0f0f0",
    position: "relative",
    paddingLeft: "30px",
    "&::before": {
      content: '"✓"',
      color: "#28a745",
      fontWeight: "bold",
      position: "absolute",
      left: 0,
      fontSize: "1.2rem",
    },
    "&:last-child": {
      borderBottom: "none",
    },
  },
};

const servicesTitleSx: SxProps<Theme> = {
  textAlign: "center",
  fontSize: "2rem",
  marginBottom: "40px",
  color: "#1a1a2e",
  fontWeight: 600,
};

const serviceItemSx: SxProps<Theme> = {
  height: "100%",
};

const serviceItemDescriptionSx: SxProps<Theme> = {
  color: "#666",
  fontSize: "0.95rem",
  lineHeight: 1.6,
};
